import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  bgColor: {
    id: 'Colore di sfondo',
    defaultMessage: 'Colore di sfondo',
  },
  addSectionButton: {
    id: 'Aggiungi una sezione',
    defaultMessage: 'Aggiungi una sezione',
  },
  addSectionTitle: {
    id: 'Titolo',
    defaultMessage: 'Titolo',
  },
  accordionSection: {
    id: 'Sezione',
    defaultMessage: 'Sezione',
  },
});

const SchemaTeaching = (props) => {
  const intl = useIntl();

  return {
    title: 'Blocco Insegnamenti',
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['variant'],
      },
    ],
    properties: {
      // title: {
      //   title: intl.formatMessage(messages.addSectionTitle),
      //   fieldsets: [
      //     {
      //       id: 'default',
      //       title: 'Default',
      //       fields: ['title'],
      //     },
      //   ],
      //   required: [],
      // },
      variant: {
        title: 'Tipologia di visualizzazione',
        default: 'list',
        choices: [
          ['diagram', 'Piano Didattico'],
          ['list', 'Elenco Insegnamenti'],
        ],
      },
    },
  };
};
export default SchemaTeaching;
